import { render, staticRenderFns } from "./Seccion_cliente.vue?vue&type=template&id=056469c7&lang=pug&"
import script from "./Seccion_cliente.vue?vue&type=script&lang=js&"
export * from "./Seccion_cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports